import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import defaultStyles from './dailyBatchHist.module.scss';
import { dailyBatchHistConnected, refreshDailyBatchHist, setGridSorts, selectRun, deselectRun } from './actions';
import GridHeader from '../../common/gridheader/GridHeader';
import Grid from '../../webcommon/grid/Grid';
import { dailyBatchHistColumns } from './constants';
import { getTimeStamp } from '../../webcommon/common/helpers';
import * as selectors from './selectors';
import { getDefaultSort, getDateFrom, getDateTo, getRows, getSelectedRunId, getRunDetail, getLoadingRunDetail } from './selectors';
import { findGridSort } from '../../common/helpermethods/HelperMethods';
import { getFilters } from '../../webcommon/header/filterheader/selectors';
import DailyBatchRunDetail from './DailyBatchRunDetail';

const DailyBatchHist = (props) => {
    const {
        dailyBatchHistConnected,
        rows,
        location,
        selectedRunId,
        runDetail,
        loadingRunDetail,
        selectRun,
        deselectRun,
    } = props;

    useEffect(() => {
        dailyBatchHistConnected(location.search);
    }, [dailyBatchHistConnected, location]);

    const handleViewRun = useCallback((runId) => {
        selectRun(runId);
    }, [selectRun]);

    const columnsWithView = [
        ...dailyBatchHistColumns,
        {
            Header: '',
            id: 'viewAction',
            sortable: false,
            width: 70,
            Cell: row => (
                <button
                    className={props.styles.viewButton}
                    onClick={() => handleViewRun(row.original.runId)}
                    type="button"
                >
                    View
                </button>
            ),
        },
    ];

    if (selectedRunId) {
        return (
            <div className={props.styles.wrapper}>
                <DailyBatchRunDetail
                    detail={runDetail}
                    loading={loadingRunDetail}
                    onBack={deselectRun}
                />
            </div>
        );
    }

    return (
        <div className={props.styles.wrapper}>
            <div className={props.styles.grid}>
                <GridHeader
                    title="Daily Batch History"
                    refreshControlsActive
                    refreshData={props.refreshDailyBatchHist}
                    lastUpdated={props.lastUpdated}
                />
                <div className={props.styles.separator}>&nbsp;</div>
                <Grid
                    sortable
                    columns={columnsWithView}
                    rows={props.rows}
                    loading={props.loading}
                    defaultSorted={findGridSort(props.defaultSort, 'timestampSort')}
                    onSortedChange={(newSorted) => { props.setGridSorts('timestampSort', newSorted); }}
                />
            </div>
        </div>
    );
};

DailyBatchHist.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired,
    dailyBatchHistConnected: PropTypes.func.isRequired,
    rows: PropTypes.arrayOf(PropTypes.shape({})),
    styles: PropTypes.objectOf(PropTypes.string),
    selectedRunId: PropTypes.string,
    runDetail: PropTypes.shape({}),
    loadingRunDetail: PropTypes.bool,
    selectRun: PropTypes.func.isRequired,
    deselectRun: PropTypes.func.isRequired,
};

DailyBatchHist.defaultProps = {
    styles: defaultStyles,
    lastUpdated: getTimeStamp(),
    rows: [],
    selectedRunId: null,
    runDetail: null,
    loadingRunDetail: false,
};

const mapDispatchToProps = {
    dailyBatchHistConnected,
    refreshDailyBatchHist,
    setGridSorts,
    selectRun,
    deselectRun,
};

const mapStateToProps = state => ({
    rows: getRows(state),
    loading: state.dailyBatchHist.loadingDailyBatchHist,
    lastUpdated: selectors.getDailyBatchHistLastUpdated(state),
    defaultSort: getDefaultSort(state),
    dateFrom: getDateFrom(getFilters(state, 'DailyBatchHist')),
    dateTo: getDateTo(getFilters(state, 'DailyBatchHist')),
    selectedRunId: getSelectedRunId(state),
    runDetail: getRunDetail(state),
    loadingRunDetail: getLoadingRunDetail(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DailyBatchHist));
